<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('jpg-to-pdf-converter', 'JPG → PDF');

function handleBatchCreated(batchId: string) {
  console.log('[JPG→PDF Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[JPG→PDF Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[JPG→PDF Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[JPG→PDF Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[JPG→PDF Converter] Credits updated:', credits);
}
</script>
